export default "__VITE_ASSET__rLt6XOMj__"